import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Rule_execution_performance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.rule_execution_performance_Id,
          sortable: true,
          cell: (row) => <span>{row.rule_execution_performance_Id}</span>,
        },
        { name: "Table Rule Triggers Id ", selector: (row, i) => row.table_rule_triggers_id, sortable: true, cell: (row) => <span>{row.table_rule_triggers_id}</span>, }, { name: "Execution Date", selector: (row, i) => row.execution_date, sortable: true, cell: (row) => <span>{row.execution_date}</span>, }, { name: "Total Executions", selector: (row, i) => row.total_executions, sortable: true, cell: (row) => <span>{row.total_executions}</span>, }, { name: "Successful Executions", selector: (row, i) => row.successful_executions, sortable: true, cell: (row) => <span>{row.successful_executions}</span>, }, { name: "Failed Executions", selector: (row, i) => row.failed_executions, sortable: true, cell: (row) => <span>{row.failed_executions}</span>, }, { name: "Avg Execution Time Ms", selector: (row, i) => row.avg_execution_time_ms, sortable: true, cell: (row) => <span>{row.avg_execution_time_ms}</span>, }, { name: "Min Execution Time Ms", selector: (row, i) => row.min_execution_time_ms, sortable: true, cell: (row) => <span>{row.min_execution_time_ms}</span>, }, { name: "Max Execution Time Ms", selector: (row, i) => row.max_execution_time_ms, sortable: true, cell: (row) => <span>{row.max_execution_time_ms}</span>, }, { name: "Cross Table Lookups Performed", selector: (row, i) => row.cross_table_lookups_performed, sortable: true, cell: (row) => <span>{row.cross_table_lookups_performed}</span>, }, { name: "Cache Hits", selector: (row, i) => row.cache_hits, sortable: true, cell: (row) => <span>{row.cache_hits}</span>, }, { name: "Cache Misses", selector: (row, i) => row.cache_misses, sortable: true, cell: (row) => <span>{row.cache_misses}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Rule_execution_performanceeditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      rule_execution_performance_Id: "",
      table_rule_triggers_id: '', execution_date: '', total_executions: '', successful_executions: '', failed_executions: '', avg_execution_time_ms: '', min_execution_time_ms: '', max_execution_time_ms: '', cross_table_lookups_performed: '', cache_hits: '', cache_misses: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'table_rule_triggers_id', inputType: 'Number', displayName: 'Table Rule Triggers Id ', validationOptions: { isRequired: false } },
      { fieldName: 'execution_date', inputType: 'Date', displayName: 'Execution Date', validationOptions: { isRequired: false } },
      { fieldName: 'total_executions', inputType: 'Number', displayName: 'Total Executions', validationOptions: { isRequired: false } },
      { fieldName: 'successful_executions', inputType: 'Number', displayName: 'Successful Executions', validationOptions: { isRequired: false } },
      { fieldName: 'failed_executions', inputType: 'Number', displayName: 'Failed Executions', validationOptions: { isRequired: false } },
      { fieldName: 'avg_execution_time_ms', inputType: 'Number', displayName: 'Avg Execution Time Ms', validationOptions: { isRequired: false } },
      { fieldName: 'min_execution_time_ms', inputType: 'Number', displayName: 'Min Execution Time Ms', validationOptions: { isRequired: false } },
      { fieldName: 'max_execution_time_ms', inputType: 'Number', displayName: 'Max Execution Time Ms', validationOptions: { isRequired: false } },
      { fieldName: 'cross_table_lookups_performed', inputType: 'Number', displayName: 'Cross Table Lookups Performed', validationOptions: { isRequired: false } },
      { fieldName: 'cache_hits', inputType: 'Number', displayName: 'Cache Hits', validationOptions: { isRequired: false } },
      { fieldName: 'cache_misses', inputType: 'Number', displayName: 'Cache Misses', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      table_rule_triggers_id: '', execution_date: '', total_executions: '', successful_executions: '', failed_executions: '', avg_execution_time_ms: '', min_execution_time_ms: '', max_execution_time_ms: '', cross_table_lookups_performed: '', cache_hits: '', cache_misses: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      table_rule_triggers_id: '', execution_date: '', total_executions: '', successful_executions: '', failed_executions: '', avg_execution_time_ms: '', min_execution_time_ms: '', max_execution_time_ms: '', cross_table_lookups_performed: '', cache_hits: '', cache_misses: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Rule_execution_performanceeditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      rule_execution_performance_Id: row.rule_execution_performance_Id,
      table_rule_triggers_id: row.table_rule_triggers_id, execution_date: row.execution_date, total_executions: row.total_executions, successful_executions: row.successful_executions, failed_executions: row.failed_executions, avg_execution_time_ms: row.avg_execution_time_ms, min_execution_time_ms: row.min_execution_time_ms, max_execution_time_ms: row.max_execution_time_ms, cross_table_lookups_performed: row.cross_table_lookups_performed, cache_hits: row.cache_hits, cache_misses: row.cache_misses,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Rule_execution_performancefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Rule_execution_performance/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Rule_execution_performancesubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('table_rule_triggers_id', this.state.table_rule_triggers_id);
    formData.append('execution_date', this.state.execution_date);
    formData.append('total_executions', this.state.total_executions);
    formData.append('successful_executions', this.state.successful_executions);
    formData.append('failed_executions', this.state.failed_executions);
    formData.append('avg_execution_time_ms', this.state.avg_execution_time_ms);
    formData.append('min_execution_time_ms', this.state.min_execution_time_ms);
    formData.append('max_execution_time_ms', this.state.max_execution_time_ms);
    formData.append('cross_table_lookups_performed', this.state.cross_table_lookups_performed);
    formData.append('cache_hits', this.state.cache_hits);
    formData.append('cache_misses', this.state.cache_misses);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Rule_execution_performance/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Rule_execution_performancefetchHandler();
          this.handleOffcanvasClose();
          this.setState({ table_rule_triggers_id: '', execution_date: '', total_executions: '', successful_executions: '', failed_executions: '', avg_execution_time_ms: '', min_execution_time_ms: '', max_execution_time_ms: '', cross_table_lookups_performed: '', cache_hits: '', cache_misses: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Rule_execution_performanceupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("rule_execution_performance_Id", this.state.rule_execution_performance_Id);
    formData.append('table_rule_triggers_id', this.state.table_rule_triggers_id);
    formData.append('execution_date', this.state.execution_date);
    formData.append('total_executions', this.state.total_executions);
    formData.append('successful_executions', this.state.successful_executions);
    formData.append('failed_executions', this.state.failed_executions);
    formData.append('avg_execution_time_ms', this.state.avg_execution_time_ms);
    formData.append('min_execution_time_ms', this.state.min_execution_time_ms);
    formData.append('max_execution_time_ms', this.state.max_execution_time_ms);
    formData.append('cross_table_lookups_performed', this.state.cross_table_lookups_performed);
    formData.append('cache_hits', this.state.cache_hits);
    formData.append('cache_misses', this.state.cache_misses);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Rule_execution_performance/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Rule_execution_performancefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Rule_execution_performancefetchHandler();

    //***componentDidMount
  }

  handletable_rule_triggers_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ table_rule_triggers_id: fieldValue });
  }; handleexecution_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ execution_date: fieldValue });
  }; handletotal_executionsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ total_executions: fieldValue });
  }; handlesuccessful_executionsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ successful_executions: fieldValue });
  }; handlefailed_executionsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ failed_executions: fieldValue });
  }; handleavg_execution_time_msChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ avg_execution_time_ms: fieldValue });
  }; handlemin_execution_time_msChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ min_execution_time_ms: fieldValue });
  }; handlemax_execution_time_msChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ max_execution_time_ms: fieldValue });
  }; handlecross_table_lookups_performedChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ cross_table_lookups_performed: fieldValue });
  }; handlecache_hitsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ cache_hits: fieldValue });
  }; handlecache_missesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ cache_misses: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this rule_execution_performance?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('rule_execution_performance_Id', row.rule_execution_performance_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Rule_execution_performance/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Rule_execution_performancefetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Rule Execution Performance</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Rule_execution_performance</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Table Rule Triggers Id </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handletable_rule_triggers_idChange} className="form-control" name="table_rule_triggers_id" value={this.state.table_rule_triggers_id} required="required" placeholder="Enter Table Rule Triggers Id " />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_rule_triggers_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Execution Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handleexecution_dateChange} className="form-control" name="execution_date" value={this.state.execution_date} required="required" placeholder="Enter Execution Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.execution_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Total Executions</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handletotal_executionsChange} className="form-control" name="total_executions" value={this.state.total_executions} required="required" placeholder="Enter Total Executions" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.total_executions} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Successful Executions</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlesuccessful_executionsChange} className="form-control" name="successful_executions" value={this.state.successful_executions} required="required" placeholder="Enter Successful Executions" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.successful_executions} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Failed Executions</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlefailed_executionsChange} className="form-control" name="failed_executions" value={this.state.failed_executions} required="required" placeholder="Enter Failed Executions" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.failed_executions} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Avg Execution Time Ms</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleavg_execution_time_msChange} className="form-control" name="avg_execution_time_ms" value={this.state.avg_execution_time_ms} required="required" placeholder="Enter Avg Execution Time Ms" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.avg_execution_time_ms} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Min Execution Time Ms</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlemin_execution_time_msChange} className="form-control" name="min_execution_time_ms" value={this.state.min_execution_time_ms} required="required" placeholder="Enter Min Execution Time Ms" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.min_execution_time_ms} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Max Execution Time Ms</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlemax_execution_time_msChange} className="form-control" name="max_execution_time_ms" value={this.state.max_execution_time_ms} required="required" placeholder="Enter Max Execution Time Ms" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.max_execution_time_ms} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Cross Table Lookups Performed</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecross_table_lookups_performedChange} className="form-control" name="cross_table_lookups_performed" value={this.state.cross_table_lookups_performed} required="required" placeholder="Enter Cross Table Lookups Performed" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.cross_table_lookups_performed} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Cache Hits</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecache_hitsChange} className="form-control" name="cache_hits" value={this.state.cache_hits} required="required" placeholder="Enter Cache Hits" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.cache_hits} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Cache Misses</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecache_missesChange} className="form-control" name="cache_misses" value={this.state.cache_misses} required="required" placeholder="Enter Cache Misses" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.cache_misses} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Rule_execution_performancesubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Rule_execution_performance</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Table Rule Triggers Id </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handletable_rule_triggers_idChange} className="form-control" name="table_rule_triggers_id" value={this.state.table_rule_triggers_id} required="required" placeholder="Enter Table Rule Triggers Id " />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_rule_triggers_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Execution Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handleexecution_dateChange} className="form-control" name="execution_date" value={this.state.execution_date} required="required" placeholder="Enter Execution Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.execution_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Total Executions</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handletotal_executionsChange} className="form-control" name="total_executions" value={this.state.total_executions} required="required" placeholder="Enter Total Executions" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.total_executions} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Successful Executions</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlesuccessful_executionsChange} className="form-control" name="successful_executions" value={this.state.successful_executions} required="required" placeholder="Enter Successful Executions" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.successful_executions} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Failed Executions</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlefailed_executionsChange} className="form-control" name="failed_executions" value={this.state.failed_executions} required="required" placeholder="Enter Failed Executions" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.failed_executions} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Avg Execution Time Ms</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleavg_execution_time_msChange} className="form-control" name="avg_execution_time_ms" value={this.state.avg_execution_time_ms} required="required" placeholder="Enter Avg Execution Time Ms" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.avg_execution_time_ms} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Min Execution Time Ms</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlemin_execution_time_msChange} className="form-control" name="min_execution_time_ms" value={this.state.min_execution_time_ms} required="required" placeholder="Enter Min Execution Time Ms" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.min_execution_time_ms} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Max Execution Time Ms</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlemax_execution_time_msChange} className="form-control" name="max_execution_time_ms" value={this.state.max_execution_time_ms} required="required" placeholder="Enter Max Execution Time Ms" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.max_execution_time_ms} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Cross Table Lookups Performed</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecross_table_lookups_performedChange} className="form-control" name="cross_table_lookups_performed" value={this.state.cross_table_lookups_performed} required="required" placeholder="Enter Cross Table Lookups Performed" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.cross_table_lookups_performed} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Cache Hits</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecache_hitsChange} className="form-control" name="cache_hits" value={this.state.cache_hits} required="required" placeholder="Enter Cache Hits" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.cache_hits} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Cache Misses</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecache_missesChange} className="form-control" name="cache_misses" value={this.state.cache_misses} required="required" placeholder="Enter Cache Misses" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.cache_misses} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Rule_execution_performanceupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}